import { Select, SelectValue, SelectTrigger, SelectContent, SelectItem } from '@/components/ui/select';
import React from 'react';

interface UnitTableSortProps {
    selectedSort: string;
    setSelectedSort: React.Dispatch<React.SetStateAction<string>>;
}

export const UnitTableSort: React.FC<UnitTableSortProps> = ({selectedSort, setSelectedSort}) => {
    return (
        <Select value={selectedSort} onValueChange={(value) => setSelectedSort(value)}>
            <SelectTrigger>
                <SelectValue placeholder="Sort By" />
            </SelectTrigger>
            <SelectContent className="se-vapor se-vapor-sort">
                <SelectItem value='vacancy:asc'>Availability: Low - High</SelectItem>
                <SelectItem value='vacancy:desc'>Availability: High - Low</SelectItem>
                <SelectItem value='price:asc'>Price: Low - High</SelectItem>
                <SelectItem value='price:desc'>Price: High - Low</SelectItem>
                <SelectItem value='area:asc'>Size: Small - Large</SelectItem>
                <SelectItem value='area:desc'>Size: Large - Small</SelectItem>
            </SelectContent>
        </Select>
    )
}